import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import MuiButton, {} from '@mui/material/Button';
import MuiIconButton, {} from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
export const Button = forwardRef(function Button({ busy = false, busyLabel = 'Working…', children, disabled, variant = 'outlined', ...rest }, ref) {
    return (_jsx(MuiButton, { ref: ref, variant: variant, disabled: disabled || busy, "aria-busy": busy || undefined, ...rest, children: busy ? busyLabel : children }));
});
export const IconButton = forwardRef(function IconButton({ label, children, tooltip = true, ...rest }, ref) {
    const button = (_jsx(MuiIconButton, { ref: ref, "aria-label": label, ...rest, children: children }));
    if (!tooltip || rest.disabled)
        return button;
    return _jsx(Tooltip, { title: label, children: button });
});
//# sourceMappingURL=button.js.map